import React from 'react';
import { Scissors, Instagram, Phone, MapPin } from 'lucide-react';
import { shopInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="relative bg-[#080808] border-t border-[#c9a961]/15 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full border border-[#c9a961]/60 flex items-center justify-center">
              <Scissors className="w-4 h-4 text-[#c9a961]" />
            </div>
            <div>
              <div className="font-display text-2xl text-[#f5efe4]">JR Barber</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a961]">Toulouse</div>
            </div>
          </div>
          <p className="mt-5 text-[#c8beab] max-w-md text-sm leading-relaxed">
            L’art du rasage et de la coupe précise, dans un salon soigné et professionnel
            au cœur de Ramonville.
          </p>
        </div>

        <div>
          <h4 className="text-[#c9a961] uppercase tracking-widest text-xs mb-5">Navigation</h4>
          <ul className="space-y-3 text-sm">
            {['Le salon','Prestations','Galerie','Horaires','Avis','Contact'].map((l, i) => (
              <li key={l}>
                <a
                  href={['#salon','#services','#gallery','#hours','#reviews','#contact'][i]}
                  className="text-[#c8beab] hover:text-[#c9a961] transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-[#c9a961] uppercase tracking-widest text-xs mb-5">Contact</h4>
          <ul className="space-y-4 text-sm text-[#c8beab]">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#c9a961] mt-0.5" />
              {shopInfo.address}
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#c9a961]" />
              {shopInfo.phone}
            </li>
            <li className="flex items-center gap-3">
              <Instagram className="w-4 h-4 text-[#c9a961]" />
              <a href={shopInfo.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-[#c9a961]">
                @{shopInfo.instagram}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-6 border-t border-[#c9a961]/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#a8a29e]">
        <div>© {new Date().getFullYear()} JR Barber. Tous droits réservés.</div>
        <div className="font-bebas tracking-widest text-[#c9a961]">FADE. TRIM. STYLE.</div>
      </div>
    </footer>
  );
};

export default Footer;
